import script from "./ModalReportHolidays.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalReportHolidays.vue?vue&type=script&setup=true&lang=js"

import "./ModalReportHolidays.vue?vue&type=style&index=0&id=b8652adc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8652adc"]])

export default __exports__